import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormRecord } from '../../models/forms/formRecords.model';
import { PaginationParams } from './../../models/shared/paginationParams.model';
import { ApiService } from './../../shared/services/api.service';
import { Subscription } from 'rxjs';
import { CommunicationService } from './../../shared/services/communication.service';

@Component({
    selector: 'swb-estate-form-records',
    templateUrl: './estate-form-records.component.html'
})
export class EstateFormRecordsComponent implements OnInit, OnDestroy {
    private _subscription = new Subscription();

    public records: FormRecord[];
    public isInitialized = false;

    public pagination: PaginationParams = {
        pageSize: 0,
        total: 0
    };

    public p = 1;

    constructor(
        private _apiService: ApiService,
        private _communicationService: CommunicationService
    ) { }

    public ngOnInit(): void {
        this._getPaginationParams('');
        this._getRecords('formrecords/listnamed/real-estate');
        this._subscription = this._communicationService.modalExecuted$.subscribe(
            () => {
                this._getRecords('formrecords/listnamed/real-estate');
            }
        );
    }

    public ngOnDestroy(): void {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    }

    public pageChanged(p: number): void {
        this.p = p;
        this._getRecords('formrecords/listnamed/real-estate');
    }

    public generateArray(obj: string): Array<any> {
        obj = JSON.parse(obj);
        return Object.keys(obj).map((key) => ({ key: key, value: obj[key] }));
    }

    private _getRecords(uri: string): void {
        this._apiService.get(uri + '?page=' + this.p)
            .subscribe(
                (response: any) => {
                    this.records = { ...response }.data;
                    this.isInitialized = true;
                },
                (error) => console.error(error)
            );
    }

    private _getPaginationParams(query: string) {
        this._apiService.get('formrecords/paginationnamed/real-estate/' + query)
            .subscribe(
                (response: any) => {
                    this.pagination = { ...response?.data };
                },
                (error) => console.error(error)
            );
    }

}
